import { useEffect } from 'react';
import { AccountId, UserId } from 'api/models';
import { AccountSocketData, EventType, pushes } from 'api/pushes';
import { UserChannel } from 'api/pushes/channels';
import { useAccount } from './use-account';
import { useUser } from './use-user';

export const useUserWsUpdates = <T>(
  handler: (socketData: AccountSocketData<T>) => void,
  [action, objectType]: EventType,
): void => {
  const {
    user: { userId },
  } = useUser();
  const { accountId } = useAccount();

  useEffect(() => {
    const channel = UserChannel(AccountId(accountId), UserId(userId));
    const subscription = pushes<T>(channel, [action, objectType]).subscribe(
      handler,
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [accountId, userId, action, objectType, handler]);
};
